/*  Shared  */
import { SessionHelper } from 'application/Shared/Helpers';
import { debug } from 'application/Shared/Utils';

/*  Hooks  */
import { useSession } from 'hooks/redux/Selectors/session';

/*  React  */
import React from 'react';
import { useLocation } from 'react-router';

export const Permission = ({
    children,
    required,
    operator
}: {
    children: React.ReactNode;
    required: string | string[];
    operator?: 'and' | 'or';
}) => {
    const location = useLocation();
    const session = useSession();
    const sessionHelper = new SessionHelper(session);
    const permission = sessionHelper.hasPermission(required, operator);

    if (!permission) {
        debug.dev('Insufficient Permission', required, operator, location);
        return null;
    }
    return children;
};
